function dataExists (channelData = []) {
  return channelData && Array.isArray(channelData) && channelData.length
}

function getGenres (channelData = []) {
  if (!dataExists(channelData)) return []
  const genres = []
  const genresHelper = []
  channelData.forEach(channel => {
    channel.categories.forEach(cat => {
      if (!genresHelper.includes(cat.code)) {
        genresHelper.push(cat.code)
        const categoryWithValue = {
          ...cat,
          value: cat.name
        }
        genres.push(categoryWithValue)
      }
    })
  })

  return genres
}

function filterUniqueData (data = [], filterByProp = 'value') {
  const unique = []
  const uniqueHelper = []
  let clonedData = []
  if (data.every(entry => Array.isArray(entry))) { // uvek je multi-dimenzionalni array, ali za svaki slučaj flatujemo array
    clonedData = data.flat()
  } else {
    clonedData = [...data]
  }

  clonedData.forEach(d => {
    if (!uniqueHelper.includes(d[filterByProp])) {
      uniqueHelper.push(d[filterByProp])
      unique.push(d)
    }
  })

  return unique
}

function filterDataByName (source = [], matchProp = '', matchValue = '') {
  if (!dataExists(source)) return []
  const results = []

  function innerFilter (innerSource = [], innerMatchProp = '', innerMatchValue = '') {
    for (const prop in innerSource) {
      if (typeof innerSource[prop][innerMatchProp] === 'string' && innerSource[prop][innerMatchProp].toLowerCase().indexOf(innerMatchValue.toLowerCase()) > -1) {
        if (innerSource[prop].featureValues) {
          results.push([...innerSource[prop].featureValues])
        } else {
          results.push([...innerSource[prop]])
        }
      } else if (typeof innerSource[prop] === 'object') {
        innerFilter(innerSource[prop], innerMatchProp, innerMatchValue)
      }
    }
  }

  innerFilter(source, matchProp, matchValue)

  return results
}

function getFilterData (source = [], matchProp = '', matchValue = '') {
  return filterUniqueData(filterDataByName(source, matchProp, matchValue))
}

export function createFiltersFromChannelData (channelData = []) {
  return new Promise((resolve) => {
    // ukljucuje pakete i addonove, jer su iz nekog razloga stavljeni u isti niz, pod istim nazivom
    const packagesAndAddons = getFilterData(channelData, 'name', 'paket')
    const packages = packagesAndAddons.filter(p => p.category)
    const addons = packagesAndAddons.filter(p => !p.category)
    return resolve({
      packages,
      addons,
      genres: getGenres(channelData),
      languages: getFilterData(channelData, 'name', 'Jezik'),
      quality: getFilterData(channelData, 'name', 'Kvalitet'),
      channelType: getFilterData(channelData, 'name', 'Tip kanala')
    })
  })
}
